const PlusIcon = () => {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  fill="none"
                  viewBox="0 0 477 420"
            >
                  <mask
                        id="mask0_1754_16874"
                        style={{ maskType: "luminance" }}
                        width="267"
                        height="296"
                        x="110"
                        y="132"
                        maskUnits="userSpaceOnUse"
                  >
                        <path
                              fill="#fff"
                              d="M110.528 132.168h266.337v295.231H110.528V132.168z"
                        ></path>
                  </mask>
                  <g mask="url(#mask0_1754_16874)">
                        <mask
                              id="mask1_1754_16874"
                              style={{ maskType: "luminance" }}
                              width="160"
                              height="283"
                              x="158"
                              y="140"
                              maskUnits="userSpaceOnUse"
                        >
                              <path
                                    fill="#fff"
                                    d="M317.564 140.703v281.622H158.646V281.63c0-77.729 71.006-140.927 158.918-140.927z"
                              ></path>
                        </mask>
                        <g mask="url(#mask1_1754_16874)">
                              <path
                                    fill="url(#paint0_linear_1754_16874)"
                                    d="M317.564 140.703H158.646v281.622h158.918V140.703z"
                              ></path>
                        </g>
                  </g>
                  <mask
                        id="mask2_1754_16874"
                        style={{ maskType: "luminance" }}
                        width="368"
                        height="178"
                        x="110"
                        y="132"
                        maskUnits="userSpaceOnUse"
                  >
                        <path
                              fill="#fff"
                              d="M110.528 132.168h366.473v177.138H110.528V132.168z"
                        ></path>
                  </mask>
                  <g mask="url(#mask2_1754_16874)">
                        <mask
                              id="mask3_1754_16874"
                              style={{ maskType: "luminance" }}
                              width="318"
                              height="142"
                              x="159"
                              y="140"
                              maskUnits="userSpaceOnUse"
                        >
                              <path
                                    fill="#fff"
                                    d="M159.166 281.63c0-77.729 71.006-140.927 158.657-140.927h158.918V281.63H159.166z"
                              ></path>
                        </mask>
                        <g mask="url(#mask3_1754_16874)">
                              <path
                                    fill="url(#paint1_linear_1754_16874)"
                                    d="M476.741 140.703H159.166V281.63h317.575V140.703z"
                              ></path>
                        </g>
                  </g>
                  <mask
                        id="mask4_1754_16874"
                        style={{ maskType: "luminance" }}
                        width="160"
                        height="282"
                        x="159"
                        y="0"
                        maskUnits="userSpaceOnUse"
                  >
                        <path
                              fill="#fff"
                              d="M159.424 281.622V0h158.657v140.696c0 77.959-71.006 140.926-158.657 140.926z"
                        ></path>
                  </mask>
                  <g mask="url(#mask4_1754_16874)">
                        <path
                              fill="url(#paint2_linear_1754_16874)"
                              d="M159.424 281.622h158.657V0H159.424v281.622z"
                        ></path>
                  </g>
                  <mask
                        id="mask5_1754_16874"
                        style={{ maskType: "luminance" }}
                        width="377"
                        height="178"
                        x="0"
                        y="132"
                        maskUnits="userSpaceOnUse"
                  >
                        <path
                              fill="#fff"
                              d="M0 132.168h376.876v177.138H0V132.168z"
                        ></path>
                  </mask>
                  <g mask="url(#mask5_1754_16874)">
                        <mask
                              id="mask6_1754_16874"
                              style={{ maskType: "luminance" }}
                              width="319"
                              height="142"
                              x="-1"
                              y="140"
                              maskUnits="userSpaceOnUse"
                        >
                              <path
                                    fill="#fff"
                                    d="M317.571 140.703c0 77.729-71.006 140.927-158.658 140.927H-.004V140.703h317.575z"
                              ></path>
                        </mask>
                        <g mask="url(#mask6_1754_16874)">
                              <path
                                    fill="url(#paint3_linear_1754_16874)"
                                    d="M-.004 281.63h317.575V140.703H-.004V281.63z"
                              ></path>
                        </g>
                  </g>
                  <defs>
                        <linearGradient
                              id="paint0_linear_1754_16874"
                              x1="238.068"
                              x2="238.068"
                              y1="140.773"
                              y2="422.426"
                              gradientUnits="userSpaceOnUse"
                        >
                              <stop stopColor="#5080FD"></stop>
                              <stop offset="0.25" stopColor="#5080FD"></stop>
                              <stop offset="0.313" stopColor="#5080FD"></stop>
                              <stop offset="0.344" stopColor="#5080FD"></stop>
                              <stop offset="0.352" stopColor="#5081FD"></stop>
                              <stop offset="0.359" stopColor="#5181FD"></stop>
                              <stop offset="0.367" stopColor="#5182FD"></stop>
                              <stop offset="0.375" stopColor="#5182FD"></stop>
                              <stop offset="0.383" stopColor="#5183FD"></stop>
                              <stop offset="0.391" stopColor="#5184FD"></stop>
                              <stop offset="0.398" stopColor="#5284FD"></stop>
                              <stop offset="0.406" stopColor="#5285FD"></stop>
                              <stop offset="0.414" stopColor="#5285FD"></stop>
                              <stop offset="0.422" stopColor="#5286FD"></stop>
                              <stop offset="0.43" stopColor="#5286FD"></stop>
                              <stop offset="0.438" stopColor="#5387FD"></stop>
                              <stop offset="0.445" stopColor="#5387FD"></stop>
                              <stop offset="0.453" stopColor="#5388FD"></stop>
                              <stop offset="0.461" stopColor="#5389FD"></stop>
                              <stop offset="0.469" stopColor="#5489FD"></stop>
                              <stop offset="0.477" stopColor="#548AFD"></stop>
                              <stop offset="0.484" stopColor="#548AFD"></stop>
                              <stop offset="0.492" stopColor="#548BFD"></stop>
                              <stop offset="0.5" stopColor="#548BFD"></stop>
                              <stop offset="0.508" stopColor="#558CFD"></stop>
                              <stop offset="0.516" stopColor="#558CFD"></stop>
                              <stop offset="0.523" stopColor="#558DFD"></stop>
                              <stop offset="0.531" stopColor="#558EFD"></stop>
                              <stop offset="0.539" stopColor="#558EFD"></stop>
                              <stop offset="0.547" stopColor="#568FFD"></stop>
                              <stop offset="0.555" stopColor="#568FFD"></stop>
                              <stop offset="0.563" stopColor="#5690FD"></stop>
                              <stop offset="0.57" stopColor="#5690FD"></stop>
                              <stop offset="0.578" stopColor="#5791FD"></stop>
                              <stop offset="0.586" stopColor="#5791FD"></stop>
                              <stop offset="0.594" stopColor="#5792FD"></stop>
                              <stop offset="0.602" stopColor="#5792FD"></stop>
                              <stop offset="0.609" stopColor="#5793FD"></stop>
                              <stop offset="0.617" stopColor="#5894FD"></stop>
                              <stop offset="0.625" stopColor="#5894FD"></stop>
                              <stop offset="0.633" stopColor="#5895FD"></stop>
                              <stop offset="0.641" stopColor="#5895FD"></stop>
                              <stop offset="0.648" stopColor="#5896FD"></stop>
                              <stop offset="0.656" stopColor="#5996FC"></stop>
                              <stop offset="0.664" stopColor="#5997FC"></stop>
                              <stop offset="0.672" stopColor="#5997FC"></stop>
                              <stop offset="0.68" stopColor="#5998FC"></stop>
                              <stop offset="0.688" stopColor="#5A99FC"></stop>
                              <stop offset="0.695" stopColor="#5A99FC"></stop>
                              <stop offset="0.703" stopColor="#5A9AFC"></stop>
                              <stop offset="0.711" stopColor="#5A9AFC"></stop>
                              <stop offset="0.719" stopColor="#5A9BFC"></stop>
                              <stop offset="0.727" stopColor="#5B9BFC"></stop>
                              <stop offset="0.734" stopColor="#5B9CFC"></stop>
                              <stop offset="0.742" stopColor="#5B9CFC"></stop>
                              <stop offset="0.75" stopColor="#5B9DFC"></stop>
                              <stop offset="0.758" stopColor="#5B9EFC"></stop>
                              <stop offset="0.766" stopColor="#5C9EFC"></stop>
                              <stop offset="0.773" stopColor="#5C9FFC"></stop>
                              <stop offset="0.781" stopColor="#5C9FFC"></stop>
                              <stop offset="0.789" stopColor="#5CA0FC"></stop>
                              <stop offset="0.797" stopColor="#5DA0FC"></stop>
                              <stop offset="0.805" stopColor="#5DA1FC"></stop>
                              <stop offset="0.813" stopColor="#5DA1FC"></stop>
                              <stop offset="0.82" stopColor="#5DA2FC"></stop>
                              <stop offset="0.828" stopColor="#5DA3FC"></stop>
                              <stop offset="0.836" stopColor="#5EA3FC"></stop>
                              <stop offset="0.844" stopColor="#5EA4FC"></stop>
                              <stop offset="0.852" stopColor="#5EA4FC"></stop>
                              <stop offset="0.859" stopColor="#5EA5FC"></stop>
                              <stop offset="0.867" stopColor="#5EA5FC"></stop>
                              <stop offset="0.875" stopColor="#5FA6FC"></stop>
                              <stop offset="0.883" stopColor="#5FA6FC"></stop>
                              <stop offset="0.891" stopColor="#5FA7FC"></stop>
                              <stop offset="0.898" stopColor="#5FA8FC"></stop>
                              <stop offset="0.906" stopColor="#60A8FC"></stop>
                              <stop offset="0.914" stopColor="#60A9FC"></stop>
                              <stop offset="0.922" stopColor="#60A9FC"></stop>
                              <stop offset="0.93" stopColor="#60AAFC"></stop>
                              <stop offset="0.938" stopColor="#60AAFC"></stop>
                              <stop offset="0.945" stopColor="#61ABFC"></stop>
                              <stop offset="0.953" stopColor="#61ABFC"></stop>
                              <stop offset="0.961" stopColor="#61ACFC"></stop>
                              <stop offset="0.969" stopColor="#61ADFC"></stop>
                              <stop offset="0.977" stopColor="#61ADFC"></stop>
                              <stop offset="0.984" stopColor="#62AEFC"></stop>
                              <stop offset="0.992" stopColor="#62AEFC"></stop>
                              <stop offset="1" stopColor="#62AFFC"></stop>
                        </linearGradient>
                        <linearGradient
                              id="paint1_linear_1754_16874"
                              x1="159.098"
                              x2="476.695"
                              y1="211.189"
                              y2="211.189"
                              gradientUnits="userSpaceOnUse"
                        >
                              <stop stopColor="#5183FD"></stop>
                              <stop offset="0.016" stopColor="#5184FD"></stop>
                              <stop offset="0.031" stopColor="#5284FD"></stop>
                              <stop offset="0.047" stopColor="#5285FD"></stop>
                              <stop offset="0.063" stopColor="#5286FD"></stop>
                              <stop offset="0.078" stopColor="#5387FD"></stop>
                              <stop offset="0.094" stopColor="#5387FD"></stop>
                              <stop offset="0.109" stopColor="#5388FD"></stop>
                              <stop offset="0.125" stopColor="#5389FD"></stop>
                              <stop offset="0.141" stopColor="#548AFD"></stop>
                              <stop offset="0.156" stopColor="#548AFD"></stop>
                              <stop offset="0.172" stopColor="#548BFD"></stop>
                              <stop offset="0.188" stopColor="#558CFD"></stop>
                              <stop offset="0.203" stopColor="#558DFD"></stop>
                              <stop offset="0.219" stopColor="#558DFD"></stop>
                              <stop offset="0.234" stopColor="#568EFD"></stop>
                              <stop offset="0.25" stopColor="#568FFD"></stop>
                              <stop offset="0.266" stopColor="#5690FD"></stop>
                              <stop offset="0.281" stopColor="#5690FD"></stop>
                              <stop offset="0.297" stopColor="#5791FD"></stop>
                              <stop offset="0.313" stopColor="#5792FD"></stop>
                              <stop offset="0.328" stopColor="#5793FD"></stop>
                              <stop offset="0.344" stopColor="#5893FD"></stop>
                              <stop offset="0.359" stopColor="#5894FD"></stop>
                              <stop offset="0.375" stopColor="#5895FD"></stop>
                              <stop offset="0.391" stopColor="#5896FD"></stop>
                              <stop offset="0.406" stopColor="#5996FC"></stop>
                              <stop offset="0.422" stopColor="#5997FC"></stop>
                              <stop offset="0.438" stopColor="#5998FC"></stop>
                              <stop offset="0.453" stopColor="#5A99FC"></stop>
                              <stop offset="0.469" stopColor="#5A99FC"></stop>
                              <stop offset="0.484" stopColor="#5A9AFC"></stop>
                              <stop offset="0.5" stopColor="#5A9BFC"></stop>
                              <stop offset="0.516" stopColor="#5B9CFC"></stop>
                              <stop offset="0.531" stopColor="#5B9CFC"></stop>
                              <stop offset="0.547" stopColor="#5B9DFC"></stop>
                              <stop offset="0.563" stopColor="#5C9EFC"></stop>
                              <stop offset="0.578" stopColor="#5C9FFC"></stop>
                              <stop offset="0.594" stopColor="#5CA0FC"></stop>
                              <stop offset="0.609" stopColor="#5DA0FC"></stop>
                              <stop offset="0.625" stopColor="#5DA1FC"></stop>
                              <stop offset="0.641" stopColor="#5DA2FC"></stop>
                              <stop offset="0.656" stopColor="#5DA3FC"></stop>
                              <stop offset="0.672" stopColor="#5EA3FC"></stop>
                              <stop offset="0.688" stopColor="#5EA4FC"></stop>
                              <stop offset="0.703" stopColor="#5EA5FC"></stop>
                              <stop offset="0.719" stopColor="#5FA6FC"></stop>
                              <stop offset="0.734" stopColor="#5FA6FC"></stop>
                              <stop offset="0.75" stopColor="#5FA7FC"></stop>
                              <stop offset="0.766" stopColor="#5FA8FC"></stop>
                              <stop offset="0.781" stopColor="#60A9FC"></stop>
                              <stop offset="0.797" stopColor="#60A9FC"></stop>
                              <stop offset="0.813" stopColor="#60AAFC"></stop>
                              <stop offset="0.828" stopColor="#61ABFC"></stop>
                              <stop offset="0.844" stopColor="#61ACFC"></stop>
                              <stop offset="0.859" stopColor="#61ACFC"></stop>
                              <stop offset="0.875" stopColor="#61ADFC"></stop>
                              <stop offset="0.891" stopColor="#62AEFC"></stop>
                              <stop offset="0.906" stopColor="#62AFFC"></stop>
                              <stop offset="0.922" stopColor="#62AFFC"></stop>
                              <stop offset="0.938" stopColor="#63B0FC"></stop>
                              <stop offset="1" stopColor="#63B1FC"></stop>
                        </linearGradient>
                        <linearGradient
                              id="paint2_linear_1754_16874"
                              x1="238.713"
                              x2="238.713"
                              y1="281.598"
                              y2="-0.055"
                              gradientUnits="userSpaceOnUse"
                        >
                              <stop stopColor="#5080FD"></stop>
                              <stop offset="0.25" stopColor="#5080FD"></stop>
                              <stop offset="0.313" stopColor="#5080FD"></stop>
                              <stop offset="0.344" stopColor="#5080FD"></stop>
                              <stop offset="0.352" stopColor="#5081FD"></stop>
                              <stop offset="0.359" stopColor="#5181FD"></stop>
                              <stop offset="0.367" stopColor="#5182FD"></stop>
                              <stop offset="0.375" stopColor="#5182FD"></stop>
                              <stop offset="0.383" stopColor="#5183FD"></stop>
                              <stop offset="0.391" stopColor="#5184FD"></stop>
                              <stop offset="0.398" stopColor="#5284FD"></stop>
                              <stop offset="0.406" stopColor="#5285FD"></stop>
                              <stop offset="0.414" stopColor="#5285FD"></stop>
                              <stop offset="0.422" stopColor="#5286FD"></stop>
                              <stop offset="0.43" stopColor="#5286FD"></stop>
                              <stop offset="0.438" stopColor="#5387FD"></stop>
                              <stop offset="0.445" stopColor="#5387FD"></stop>
                              <stop offset="0.453" stopColor="#5388FD"></stop>
                              <stop offset="0.461" stopColor="#5389FD"></stop>
                              <stop offset="0.469" stopColor="#5489FD"></stop>
                              <stop offset="0.477" stopColor="#548AFD"></stop>
                              <stop offset="0.484" stopColor="#548AFD"></stop>
                              <stop offset="0.492" stopColor="#548BFD"></stop>
                              <stop offset="0.5" stopColor="#548BFD"></stop>
                              <stop offset="0.508" stopColor="#558CFD"></stop>
                              <stop offset="0.516" stopColor="#558CFD"></stop>
                              <stop offset="0.523" stopColor="#558DFD"></stop>
                              <stop offset="0.531" stopColor="#558EFD"></stop>
                              <stop offset="0.539" stopColor="#558EFD"></stop>
                              <stop offset="0.547" stopColor="#568FFD"></stop>
                              <stop offset="0.555" stopColor="#568FFD"></stop>
                              <stop offset="0.563" stopColor="#5690FD"></stop>
                              <stop offset="0.57" stopColor="#5690FD"></stop>
                              <stop offset="0.578" stopColor="#5791FD"></stop>
                              <stop offset="0.586" stopColor="#5791FD"></stop>
                              <stop offset="0.594" stopColor="#5792FD"></stop>
                              <stop offset="0.602" stopColor="#5792FD"></stop>
                              <stop offset="0.609" stopColor="#5793FD"></stop>
                              <stop offset="0.617" stopColor="#5894FD"></stop>
                              <stop offset="0.625" stopColor="#5894FD"></stop>
                              <stop offset="0.633" stopColor="#5895FD"></stop>
                              <stop offset="0.641" stopColor="#5895FD"></stop>
                              <stop offset="0.648" stopColor="#5896FD"></stop>
                              <stop offset="0.656" stopColor="#5996FC"></stop>
                              <stop offset="0.664" stopColor="#5997FC"></stop>
                              <stop offset="0.672" stopColor="#5997FC"></stop>
                              <stop offset="0.68" stopColor="#5998FC"></stop>
                              <stop offset="0.688" stopColor="#5A99FC"></stop>
                              <stop offset="0.695" stopColor="#5A99FC"></stop>
                              <stop offset="0.703" stopColor="#5A9AFC"></stop>
                              <stop offset="0.711" stopColor="#5A9AFC"></stop>
                              <stop offset="0.719" stopColor="#5A9BFC"></stop>
                              <stop offset="0.727" stopColor="#5B9BFC"></stop>
                              <stop offset="0.734" stopColor="#5B9CFC"></stop>
                              <stop offset="0.742" stopColor="#5B9CFC"></stop>
                              <stop offset="0.75" stopColor="#5B9DFC"></stop>
                              <stop offset="0.758" stopColor="#5B9EFC"></stop>
                              <stop offset="0.766" stopColor="#5C9EFC"></stop>
                              <stop offset="0.773" stopColor="#5C9FFC"></stop>
                              <stop offset="0.781" stopColor="#5C9FFC"></stop>
                              <stop offset="0.789" stopColor="#5CA0FC"></stop>
                              <stop offset="0.797" stopColor="#5DA0FC"></stop>
                              <stop offset="0.805" stopColor="#5DA1FC"></stop>
                              <stop offset="0.813" stopColor="#5DA1FC"></stop>
                              <stop offset="0.82" stopColor="#5DA2FC"></stop>
                              <stop offset="0.828" stopColor="#5DA3FC"></stop>
                              <stop offset="0.836" stopColor="#5EA3FC"></stop>
                              <stop offset="0.844" stopColor="#5EA4FC"></stop>
                              <stop offset="0.852" stopColor="#5EA4FC"></stop>
                              <stop offset="0.859" stopColor="#5EA5FC"></stop>
                              <stop offset="0.867" stopColor="#5EA5FC"></stop>
                              <stop offset="0.875" stopColor="#5FA6FC"></stop>
                              <stop offset="0.883" stopColor="#5FA6FC"></stop>
                              <stop offset="0.891" stopColor="#5FA7FC"></stop>
                              <stop offset="0.898" stopColor="#5FA8FC"></stop>
                              <stop offset="0.906" stopColor="#60A8FC"></stop>
                              <stop offset="0.914" stopColor="#60A9FC"></stop>
                              <stop offset="0.922" stopColor="#60A9FC"></stop>
                              <stop offset="0.93" stopColor="#60AAFC"></stop>
                              <stop offset="0.938" stopColor="#60AAFC"></stop>
                              <stop offset="0.945" stopColor="#61ABFC"></stop>
                              <stop offset="0.953" stopColor="#61ABFC"></stop>
                              <stop offset="0.961" stopColor="#61ACFC"></stop>
                              <stop offset="0.969" stopColor="#61ADFC"></stop>
                              <stop offset="0.977" stopColor="#61ADFC"></stop>
                              <stop offset="0.984" stopColor="#62AEFC"></stop>
                              <stop offset="0.992" stopColor="#62AEFC"></stop>
                              <stop offset="1" stopColor="#62AFFC"></stop>
                        </linearGradient>
                        <linearGradient
                              id="paint3_linear_1754_16874"
                              x1="317.697"
                              x2="0.087"
                              y1="211.188"
                              y2="211.188"
                              gradientUnits="userSpaceOnUse"
                        >
                              <stop stopColor="#5183FD"></stop>
                              <stop offset="0.016" stopColor="#5184FD"></stop>
                              <stop offset="0.031" stopColor="#5284FD"></stop>
                              <stop offset="0.047" stopColor="#5285FD"></stop>
                              <stop offset="0.063" stopColor="#5286FD"></stop>
                              <stop offset="0.078" stopColor="#5387FD"></stop>
                              <stop offset="0.094" stopColor="#5387FD"></stop>
                              <stop offset="0.109" stopColor="#5388FD"></stop>
                              <stop offset="0.125" stopColor="#5389FD"></stop>
                              <stop offset="0.141" stopColor="#548AFD"></stop>
                              <stop offset="0.156" stopColor="#548AFD"></stop>
                              <stop offset="0.172" stopColor="#548BFD"></stop>
                              <stop offset="0.188" stopColor="#558CFD"></stop>
                              <stop offset="0.203" stopColor="#558DFD"></stop>
                              <stop offset="0.219" stopColor="#558DFD"></stop>
                              <stop offset="0.234" stopColor="#568EFD"></stop>
                              <stop offset="0.25" stopColor="#568FFD"></stop>
                              <stop offset="0.266" stopColor="#5690FD"></stop>
                              <stop offset="0.281" stopColor="#5690FD"></stop>
                              <stop offset="0.297" stopColor="#5791FD"></stop>
                              <stop offset="0.313" stopColor="#5792FD"></stop>
                              <stop offset="0.328" stopColor="#5793FD"></stop>
                              <stop offset="0.344" stopColor="#5893FD"></stop>
                              <stop offset="0.359" stopColor="#5894FD"></stop>
                              <stop offset="0.375" stopColor="#5895FD"></stop>
                              <stop offset="0.391" stopColor="#5896FD"></stop>
                              <stop offset="0.406" stopColor="#5996FC"></stop>
                              <stop offset="0.422" stopColor="#5997FC"></stop>
                              <stop offset="0.438" stopColor="#5998FC"></stop>
                              <stop offset="0.453" stopColor="#5A99FC"></stop>
                              <stop offset="0.469" stopColor="#5A99FC"></stop>
                              <stop offset="0.484" stopColor="#5A9AFC"></stop>
                              <stop offset="0.5" stopColor="#5A9BFC"></stop>
                              <stop offset="0.516" stopColor="#5B9CFC"></stop>
                              <stop offset="0.531" stopColor="#5B9CFC"></stop>
                              <stop offset="0.547" stopColor="#5B9DFC"></stop>
                              <stop offset="0.563" stopColor="#5C9EFC"></stop>
                              <stop offset="0.578" stopColor="#5C9FFC"></stop>
                              <stop offset="0.594" stopColor="#5CA0FC"></stop>
                              <stop offset="0.609" stopColor="#5DA0FC"></stop>
                              <stop offset="0.625" stopColor="#5DA1FC"></stop>
                              <stop offset="0.641" stopColor="#5DA2FC"></stop>
                              <stop offset="0.656" stopColor="#5DA3FC"></stop>
                              <stop offset="0.672" stopColor="#5EA3FC"></stop>
                              <stop offset="0.688" stopColor="#5EA4FC"></stop>
                              <stop offset="0.703" stopColor="#5EA5FC"></stop>
                              <stop offset="0.719" stopColor="#5FA6FC"></stop>
                              <stop offset="0.734" stopColor="#5FA6FC"></stop>
                              <stop offset="0.75" stopColor="#5FA7FC"></stop>
                              <stop offset="0.766" stopColor="#5FA8FC"></stop>
                              <stop offset="0.781" stopColor="#60A9FC"></stop>
                              <stop offset="0.797" stopColor="#60A9FC"></stop>
                              <stop offset="0.813" stopColor="#60AAFC"></stop>
                              <stop offset="0.828" stopColor="#61ABFC"></stop>
                              <stop offset="0.844" stopColor="#61ACFC"></stop>
                              <stop offset="0.859" stopColor="#61ACFC"></stop>
                              <stop offset="0.875" stopColor="#61ADFC"></stop>
                              <stop offset="0.891" stopColor="#62AEFC"></stop>
                              <stop offset="0.906" stopColor="#62AFFC"></stop>
                              <stop offset="0.922" stopColor="#62AFFC"></stop>
                              <stop offset="0.938" stopColor="#63B0FC"></stop>
                              <stop offset="1" stopColor="#63B1FC"></stop>
                        </linearGradient>
                  </defs>
            </svg>
      );
};
export default PlusIcon;
